/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceAccountTokenResponse } from '../../models/service-account-token-response';

export interface FindTokensByUserId$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function findTokensByUserId(http: HttpClient, rootUrl: string, params: FindTokensByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceAccountTokenResponse>> {
  const rb = new RequestBuilder(rootUrl, findTokensByUserId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServiceAccountTokenResponse>;
    })
  );
}

findTokensByUserId.PATH = '/api/v1/service_account_users/{id}/tokens';
